import { render } from "./PopUpPreviewQcmPackage.vue?vue&type=template&id=60138424"
import script from "./PopUpPreviewQcmPackage.vue?vue&type=script&lang=js"
export * from "./PopUpPreviewQcmPackage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__